import { render, staticRenderFns } from "./FormGravity.vue?vue&type=template&id=018dbca6&"
import script from "./FormGravity.vue?vue&type=script&lang=js&"
export * from "./FormGravity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports